import queryString from 'query-string';
import { ParsedUrlQuery } from 'querystring';

type UrlParams = {
  url: string;
  query: ParsedUrlQuery;
};

/**
 * Stringifies URL's path and query object.
 *
 * @param urlParams - {@link UrlParams}
 *
 * @example example of usage
 * ```typescript
 * stringifyUrl({ url: 'foo/123/bar', query: { hot: 'chocolate' } });
 * // returns 'foo/123/bar?hot=chocolate`
 * ```
 *
 * @returns Stringified URL
 */
export default function stringifyUrl({ url, query }: UrlParams): string {
  const stringifiedQuery = queryString.stringify(query);
  return `${url}${stringifiedQuery ? `?${stringifiedQuery}` : ''}`;
}
